// extracted by mini-css-extract-plugin
module.exports = {"root":"AppLayout_root__1qmI7","themeLight":"AppLayout_themeLight__2VSf7"};